module.exports = __webpack_public_path__ + "img/leftbicep-mesomorph-male.7fa77a3a.svg";